import React from 'react';

const SelectedRadio = ({ color = 'currentColor' }: { color: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 2.3335C16.0627 2.3335 20.1667 6.43755 20.1667 11.5002C20.1667 16.5628 16.0627 20.6668 11 20.6668C5.93743 20.6668 1.83337 16.5628 1.83337 11.5002C1.83337 6.43755 5.93743 2.3335 11 2.3335ZM11 3.93766C6.82339 3.93766 3.43754 7.32351 3.43754 11.5002C3.43754 15.6768 6.82339 19.0627 11 19.0627C15.1767 19.0627 18.5625 15.6768 18.5625 11.5002C18.5625 7.32351 15.1767 3.93766 11 3.93766ZM16.5 11.5002C16.5 8.4626 14.0376 6.00016 11 6.00016C7.96247 6.00016 5.50004 8.4626 5.50004 11.5002C5.50004 14.5377 7.96247 17.0002 11 17.0002C14.0376 17.0002 16.5 14.5377 16.5 11.5002Z"
        fill={color}
      />
    </svg>
  );
};

export default SelectedRadio;
